import { useLayoutEffect, useRef, Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';
import StickyMobileCTA from '../esg/shared/StickyMobileCTA';

const PageLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-slate-200 dark:border-slate-700 border-t-blue-600 rounded-full animate-spin" />
  </div>
);

const PageLayout = () => {
  const location = useLocation();
  const contentRef = useRef(null);

  // useLayoutEffect fires synchronously before browser paint —
  // scroll resets and animation restarts before the user sees anything
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });

    const el = contentRef.current;
    if (el) {
      el.classList.remove('page-enter');
      void el.offsetHeight; // force reflow to restart animation
      el.classList.add('page-enter');
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-white dark:bg-[#0a0f1a] transition-colors duration-300">
      <Navbar />
      {/* contentRef wraps both main + footer so they fade in together */}
      <div ref={contentRef}>
        <main style={{ overflowX: 'clip' }}>
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </main>
        <Footer />
      </div>
      <StickyMobileCTA />
    </div>
  );
};

export default PageLayout;
